import logo from './logo.svg';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './layouts/Home/Home';
import Presentation from './layouts/Presentation/Presentation';
import Comparateur from './layouts/Comparateur/Comparateur';
import Institution from './layouts/Institution/Institution';
import Simulateur from './layouts/Simulateur/Simulateur';


function App() {
  return (
    <div className="App">
     <Router onUpdate={() => window.scrollTo(0, 0)}>
      <Routes>
          <Route path="/presentation" element={<Presentation /> } />
          <Route path="/comparateur" element={<Comparateur /> } />
          <Route path="/simulateur" element={<Simulateur /> } />
          <Route path="/institution/:id" element={<Institution /> } />
          <Route path="/home" element={<Home /> } />
          <Route path="/" element={<Home /> } />
          <Route path="/*" element={<Home /> } />
         
        </Routes> 
      </Router>
    </div>
  );
}

export default App;
